import {environment} from '../../../environments/environment';

export class DateHelper {

    public static INVALID_DATE = new Date('INVALID');
    private static readonly pattern = /(\d{2})\.(\d{2})\.(\d{4}$)/;

    public static isCorrectDateFormat(parseValue: string): boolean {
        if (!parseValue) {
            return false;
        }
        const matches = parseValue.match(this.pattern);
        return !(!matches);
    }

    public static parseToDate(dateString: string): Date {
        if (dateString === null || dateString === undefined) {
            return DateHelper.INVALID_DATE;
        }

        const matches = dateString.match(this.pattern);
        if (!matches) {
            return DateHelper.INVALID_DATE;
        }

        const parsedDate = new Date(dateString.replace(this.pattern, '$3-$2-$1'));
        // da beim parsen des Datumstring in ein Date Objekt ein "Überlauf" z.B. 29.02. stattfinden kann,
        // wird noch auf Gleichheit des zu parsenden Datumstring geprüft
        if (parsedDate.getFullYear() === Number(matches[3]) &&
            (parsedDate.getMonth() + 1) === Number(matches[2]) &&
            parsedDate.getDate() === Number(matches[1])) {
            return parsedDate;
        }
        return DateHelper.INVALID_DATE;
    }

    public static isNotInFuture(dateAsString: string): boolean {
        if (!dateAsString) {
            return true;
        }
        const date = DateHelper.isCorrectDateFormat(dateAsString) ? DateHelper.parseToDate(dateAsString) : DateHelper.INVALID_DATE;
        if (date === DateHelper.INVALID_DATE) {
            return true;
        }
        date.setHours(0, 0, 0, 0);
        const today = new Date(Date.now());
        today.setHours(0, 0, 0, 0);
        return date.getTime() <= today.getTime();
    }

    public static isDateOlderThanDeadline(): boolean {
      const currentDate = new Date();
      const dateBetPG = new Date(environment.dateBetPG);
      return currentDate < dateBetPG;
    }
}
